// User IP & Page URL
var userIP = "";
var pageURL = window.location.href;

$.getJSON("https://api.ipify.org/?format=json", function (data) {
  userIP = data.ip || "";
}).fail(function () {
  console.warn("Could not fetch user IP.");
});

// Form Validation 

$(".form_validate").each(function () {
  $(this).validate({
    rules: {
      /* ===== COMMON ===== */
      name: {
        required: true,
        minlength: 3,
        regex: /^[A-Za-z ]+( [A-Za-z]+)*$/
      },
      email: {
        required: true,
        email: true
      },
      mobile_number: {
        required: true,
        digits: true,
        minlength: 10,
        maxlength: 10
      },
      requirement: {
        required: true,
      },
      pincode: {
        required: true,
        digits: true,
        minlength: 6,
        maxlength: 6
      },
      message: {
        required: true,
        minlength: 5,
        maxlength: 1000
      },
      /* ===== CONTACT FORM (id 19) ===== */
      company_name: {
        required: true,
        minlength: 2,
        maxlength: 100
      },
      Job_title: {
        required: true,
        minlength: 2,
        maxlength: 100
      },
      subject: {
        required: true,
        minlength: 3,
        maxlength: 150
      },
      state: {
        required: true
      },
      city: {
        required: true
      }
    },
    messages: {
      name: {
        required: "Please enter your name",
        minlength: "Name must be at least 3 characters long",
        regex: "Name must contain only letters"
      },
      email: {
        required: "Please enter your email",
        email: "Please enter a valid email address"
      },
      mobile_number: {
        required: "Please enter mobile number",
        digits: "Please enter only numbers",
        minlength: "Mobile number should be 10 digits",
        maxlength: "Mobile number should be 10 digits"
      },
      message: {
        required: "Please enter your message",
        minlength: "Minimum 5 characters",
        maxlength: "Message cannot exceed 1000 characters"
      },
      pincode: {
        required: "Please enter pincode",
        digits: "Please enter only numbers",
        minlength: "pincode should be 6 digits",
        maxlength: "pincode should be 6 digits"
      },
      requirement: {
        required: "Please select your requirement"
      },
      /* ===== CONTACT FORM (id 19) ===== */
      company_name: {
        required: "Please enter your company name",
        minlength: "Company name must be at least 2 characters long",
        maxlength: "Company name cannot exceed 100 characters"
      },
      Job_title: {
        required: "Please enter your job title",
        minlength: "Job title must be at least 2 characters long",
        maxlength: "Job title cannot exceed 100 characters"
      },
      subject: {
        required: "Please enter a subject",
        minlength: "Subject must be at least 3 characters long",
        maxlength: "Subject cannot exceed 150 characters"
      },
      state: {
        required: "Please select a state"
      },
      city: {
        required: "Please select a city"
      }
    },
    errorElement: "span",
    errorPlacement: function (error, element) {
      error.addClass("error-message");

      if (element.attr("type") === "checkbox") {
        error.insertAfter(element.closest(".form-check, .checkbox-group"));
      } else if (element.hasClass("select2-hidden-accessible")) {
        // Select2 hides the real <select> and renders its own widget
        // right after it — target that widget instead.
        error.insertAfter(element.next(".select2-container"));
      } else if (element.is("select")) {
        error.insertAfter(element);
      } else {
        error.insertAfter(element);
      }
    }
  });
});

// Re-validate Select2 dropdowns immediately after a selection is made,
// so the error message clears without waiting for form submit.
$(document).on("select2:select", ".form_validate select", function () {
  var $form = $(this).closest("form");
  if ($form.data("validator")) {
    $form.validate().element($(this));
  }
});

// Add custom regex method to jQuery Validate
jQuery.validator.addMethod(
  "regex",
  function(value, element, regexp) {
    var re = new RegExp(regexp);
    return this.optional(element) || re.test(value);
  },
  "Invalid format"
);

// ---------------- COMBINED FORM SUBMIT HANDLER ----------------
// All three forms below post to the same saveEnquiryData endpoint with
// identical success/error handling. The only real differences are:
//   - which submit button to lock/unlock
//   - which field IDs to read values from
//   - what payload key each value maps to, and the form_name label
// That per-form config lives here; the submit logic itself is shared.

// Every payload key used by ANY of the three forms. Every submission
// sends all of these — if a form doesn't have a given field, it's
// sent as an empty string instead of being left out.
var ALL_FIELD_KEYS = [
  "name",
  "email",
  "mobile_number",
  "requirement",
  "application_area",
  "company",
  "title",
  "subject",
  "pincode",
  "state",
  "city",
  "message"
];

// NOTE: the form's own id ("home_form_app") and the submit button's id
// ("home_submit") are reused as-is on every page — only one of these
// three forms ever exists on a given page, so those ids can't tell us
// which *version* of the form we're looking at. Instead we detect the
// form's type by checking for a field that only exists on that version:
//   - "#application_area" only exists on the connect-expert form
//   - "#contact_company"  only exists on the contact form
//   - anything else falls back to the home form
// Everything is looked up with $form.find(...), scoped to this form
// instance, rather than a page-wide "#id" selector.
var formConfigs = {
  // (Home Page) B2B - Connect with crompton's lighting experts: 17
  home_form_app: {
    formId: "17",
    formName: "Home Page Enquiry Form",
    fields: {
      name: "#home_name",
      email: "#home_email",
      mobile_number: "#home_mobile_number",
      requirement: "#requirement",
      pincode: "#home_pincode",
      state: "#contact_state",
      city: "#contact_city",
      message: "#home_message"
    }
  },

  // (Contact Page) B2B - Contact form: 19
  contact_form_app: {
    formId: "17",
    formName: "Contact Page Enquiry Form",
    marker: "#contact_company",
    fields: {
      name: "#contact_name",
      email: "#contact_email",
      mobile_number: "#contact_mobile_number",
      company: "#contact_company",
      title: "#contact_job_title",
      subject: "#contact_subject",
      pincode: "#contact_pincode",
      state: "#contact_state",
      city: "#contact_city",
      message: "#contact_message"
    }
  },

  // B2B - Connect with crompton's lighting experts 2 (one with city state etc): 18
  connect_expert_form: {
    formId: "17",
    formName: "Application Page Enquiry Form",
    marker: "#application_area",
    fields: {
      name: "#connect_name",
      email: "#connect_email",
      mobile_number: "#connect_mobile_number",
      pincode: "#connect_pincode",
      application_area: "#application_area",
      state: "#contact_state",
      city: "#contact_city",
      message: "#connect_message"
    }
  }
};

// Figures out which config applies to this specific form instance by
// checking for each config's unique marker field inside it.
function detectFormType($form) {
  for (var key in formConfigs) {
    var marker = formConfigs[key].marker;
    if (marker && $form.find(marker).length) {
      return key;
    }
  }
  return "home_form_app"; // no marker matched -> plain home form
}

$("#home_form_app").on("submit", function (event) {
  event.preventDefault(); // Prevent default form submission

  var $form = $(this);

  if (!$form.valid()) return; // STOP if invalid

  var configKey = detectFormType($form);
  var config = formConfigs[configKey];

  var $submitBtn = $form.find("#home_submit");

  $submitBtn
    .prop("disabled", true) // Disable button
    .html(
      '<img src="https://cdn.shopify.com/s/files/1/0715/1704/5040/files/loader.gif?v=1740403215" alt="Loading..." style="width: 20px; vertical-align: middle;"> Processing...'
    );

  var form = new FormData();
  form.append("form_id", config.formId);
  form.append("form", config.formName);

  $.each(ALL_FIELD_KEYS, function (i, payloadKey) {
    var selector = config.fields[payloadKey];
    var value = selector ? $(selector).val() : "";
    form.append(payloadKey, value || "");
  });

  form.append("ip", userIP);
  form.append("page_url", pageURL);
  form.append("ua", navigator.userAgent);

  var settings = {
    url: "https://reports.crompton.co.in/forms/public/api/saveEnquiryData",
    method: "POST",
    timeout: 0,
    processData: false,
    mimeType: "multipart/form-data",
    contentType: false,
    data: form,
  };

  $.ajax(settings)
    .done(function (res) {
      let response;
      try {
        response = typeof res === "string" ? JSON.parse(res) : res;
      } catch (e) {
        console.error("Invalid JSON response", res);
        response = {};
      }

      if (response.status === "error") {
        $submitBtn.prop("disabled", false).text("Submit");
        $("#form_message")
          .text(response.message?.join(", ") || "Something went wrong.")
          .css({
            color: "red",
            background: "#ffdcdc",
            border: "1px solid red",
          })
          .show();

        setTimeout(function () {
          $("#form_message").fadeOut();
        }, 5000);

        return; // stop execution if error
      }
      // B2B pt_b2b_forms_submit
      dataLayer.push({
        event: "pt_b2b_forms_submit",
        page_url: full_url,
        user_id: customer,
        form_name: config.formName
      });

      $form[0].reset();
      unlockStateCity($form.find('[name="state"]'), $form.find('[name="city"]'));
      $submitBtn.prop("disabled", false).text("Submit");
      $("#form_message")
        .text("Your form has been submitted successfully!")
        .css("color", "green")
        .show();
      console.log(response);

      setTimeout(function () {
        $("#form_message").fadeOut();
      }, 5000);
    })
    .fail(function (jqXHR, textStatus, errorThrown) {
      $submitBtn.prop("disabled", false).text("Submit");
      $("#form_message")
        .text("Something went wrong. Please try again.")
        .css("color", "red")
        .show();

      console.error("Form submission failed:", textStatus, errorThrown);

      setTimeout(function () {
        $("#form_message").fadeOut();
      }, 5000);
    });
});

// Reverts a form's state/city fields back to the normal, editable
// pick-lists (used when a pincode is cleared, invalid, or unrecognised).
function unlockStateCity($stateSelect, $citySelect) {
  $stateSelect
    .html('<option value="">Select State*</option>')
    .prop("disabled", false)
    .css("background-color", "");

  $citySelect
    .html('<option value="">Select City*</option>')
    .prop("disabled", true)
    .css("background-color", "");
}

// Locks a form's state/city fields to a single option, exactly as
// resolved by the pincode lookup — the visitor can't edit these further,
// matching how the readonly pincode field behaves on the solar form.
function lockStateCity($stateSelect, $citySelect, stateValue, cityValue) {
  $stateSelect
    .html(`<option value="${stateValue}">${stateValue}</option>`)
    .prop("disabled", true)
    .css("background-color", "#f0f0f0");

  $citySelect
    .html(
      cityValue
        ? `<option value="${cityValue}">${cityValue}</option>`
        : '<option value="">Select City*</option>'
    )
    .prop("disabled", true)
    .css("background-color", "#f0f0f0");
}


// ---------------- PINCODE AUTO-FILL (State / City) ----------------
// Any form with a "pincode" field (Home form #17, Connect-with-expert
// form #18) gets its state + city locked to whatever Crompton's zip
// lookup service resolves, once a valid 6-digit pincode is entered.
$(document).on("input", '[name="pincode"]', function () {
  var pincode = $(this).val().trim();
  var $form = $(this).closest("form");
  var $stateSelect = $form.find('[name="state"]');
  var $citySelect = $form.find('[name="city"]');

  // Only forms that actually have state/city dropdowns need this.
  if (!$stateSelect.length) return;

  if (!/^[0-9]{6}$/.test(pincode)) {
    // Incomplete/cleared pincode — let the visitor pick manually again.
    unlockStateCity($stateSelect, $citySelect);
    return;
  }

  $stateSelect.prop("disabled", true).css("background-color", "#f0f0f0");
  $citySelect.prop("disabled", true).css("background-color", "#f0f0f0");

  $.ajax({
    url: "https://reports.crompton.co.in/api/crm/api.php?action=getZipDetails",
    method: "POST",
    dataType: "json",
    data: { pincode: pincode },

    success: function (response) {
      var wsState = response && response.data ? response.data.wSState : null;

      if (response?.status !== "success" || wsState !== 1) {
        // Pincode not recognised — let the visitor pick manually.
        unlockStateCity($stateSelect, $citySelect);
        return;
      }

      var stateName = response.data.data?.state?.value || "";
      var cityName = response.data.data?.city?.value || "";

      if (!stateName) {
        unlockStateCity($stateSelect, $citySelect);
        return;
      }

      lockStateCity($stateSelect, $citySelect, stateName, cityName);

      // Re-run validation now that the locked fields have a value.
      if ($form.data("validator")) {
        $form.validate().element($stateSelect);
        $form.validate().element($citySelect);
      }
    },

    error: function () {
      unlockStateCity($stateSelect, $citySelect);
      console.warn("Pincode lookup failed, please select state/city manually.");
    }
  });
});
